{
    "type": "object",
    "properties": {
        "id": {
            "type": "string"
        },
        "libraryId": {
            "type": "string"
        },
        "componentId": {
            "type": "string"
        },
        "name": {
            "type": "string"
        },
        "description": {
            "type": "string"
        },
        "breakpoints": {
            "type": "object",
            "additionalProperties": {
                "type": "string"
            }
        },
        "orderIdx": {
            "type": "string"
        },
        "createdAt": {
            "type": "string",
            "format": "date-time"
        },
        "modifiedAt": {
            "type": "string",
            "format": "date-time"
        }
    },
    "additionalProperties": false,
    "required": [
        "breakpoints",
        "componentId",
        "createdAt",
        "id",
        "libraryId",
        "modifiedAt",
        "name"
    ],
    "$schema": "http://json-schema.org/draft-07/schema#"
}
